module.exports = __webpack_public_path__ + "static/media/marido.a453f9cf.svg";